import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { TRIGGER_BY_KEY, ACTION_BY_KEY } from "../store/automation-getters";
import { SET_CURRENT_AUTOMATION, SET_EDITING, TOGGLE_AUTOMATION_DATA_ENABLE_BY_ID, SET_CHANGING_AUTOMATION_STATUS, CLEAR_CURRENT_AUTOMATION } from "../store/automation-mutations";
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { typeToReadOnlyComponent } from "../mixins/component-selector";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import PlanTooltip from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-tooltip.vue";
import { IS_USAGE_RESTRICTED } from "@Broker/@Modules/account-plan/store/account-plan-getters";
import { SAVE_AUTOMATION } from "@Broker/@Modules/automation/automation/store/automation-actions";
import { LOAD_PLAN_LIMIT } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import { cloneDeep, has } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {
    ProfileAvatar,
    PlanTooltip
  },
  mixins: [typeToReadOnlyComponent],
  props: {
    automation: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      labelValue: uuidv4()
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapFields("AutomationStore", ["deleting", "automationToDelete", "shareSelection"])), mapState("AccountPlanStore", ["currentPagePlan"])), mapState("AutomationStore", ["changingAutomationStatus", "editing"])), mapGetters("AutomationStore", [TRIGGER_BY_KEY, ACTION_BY_KEY])), mapGetters("AccountPlanStore", [IS_USAGE_RESTRICTED])), {}, {
    trigger() {
      return this.TRIGGER_BY_KEY(this.automation.trigger);
    },
    action() {
      return this.ACTION_BY_KEY(this.automation.action);
    },
    triggerArguments() {
      return this.automation["trigger-arguments"];
    },
    boardId() {
      if (!this.triggerArguments) return;
      const {
        board
      } = this.triggerArguments;
      return board && board.value.toString();
    },
    actionArguments() {
      var _context;
      return _filterInstanceProperty(_context = this.action["action-arguments"]).call(_context, ({
        type
      }) => (type !== "assignees" || this.boardId) && type !== "title");
    },
    owner() {
      return this.automation.owner;
    },
    shared() {
      return this.automation.shared;
    },
    automationWrapperClass() {
      return ["d-flex", "flex-wrap", "automation", `automation-${this.automation.id}`, {
        "ml-4": this.shared
      }, "w-95"];
    },
    isActive: {
      get() {
        var _this$automation$enab;
        return (_this$automation$enab = this.automation.enabled) != null ? _this$automation$enab : false;
      },
      set() {
        this.toggleEnableAutomation();
      }
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapMutations("AutomationStore", [SET_CURRENT_AUTOMATION, SET_EDITING, TOGGLE_AUTOMATION_DATA_ENABLE_BY_ID, SET_CHANGING_AUTOMATION_STATUS, CLEAR_CURRENT_AUTOMATION])), mapActions("AutomationStore", [SAVE_AUTOMATION])), mapActions("AccountPlanStore", [LOAD_PLAN_LIMIT])), {}, {
    typeToProps(actionArgument) {
      switch (actionArgument.type) {
        case "text":
          return {
            text: this.automation["action-arguments"].text,
            breakLine: true
          };
        case "checklist":
          return {
            checklist: this.automation["action-arguments"].checklist,
            title: this.automation["action-arguments"].title
          };
        case "multi-option":
          return {
            text: this.getMultiOptionText(this.automation["action-arguments"].offset)
          };
        case "email":
          return {
            value: this.automation["action-arguments"].email
          };
        case "time":
          return {
            text: moment(this.automation["action-arguments"].scheduledTime, "'HH:mm'").format("LT")
          };
        case "assignees":
          return {
            value: this.automation["action-arguments"].assignees,
            boardId: this.boardId,
            readOnly: true
          };
        case "assignees-single":
          return {
            value: this.automation["action-arguments"].assigned,
            boardId: this.boardId,
            readOnly: true
          };
        case "package-option":
          return {
            value: this.automation["action-arguments"].package,
            boardId: this.boardId,
            readOnly: true
          };
        case "boolean":
          return {
            value: this.automation["action-arguments"].pinned || this.automation["action-arguments"].sendEmailOnBehalf,
            readOnly: true
          };
        default:
          return null;
      }
    },
    getCurrentAutomationClone() {
      const automation = cloneDeep(this.automation);
      automation.action = cloneDeep(this.ACTION_BY_KEY(automation.action));
      automation.trigger = cloneDeep(this.TRIGGER_BY_KEY(automation.trigger));
      if (!has(automation, "action-arguments")) {
        automation["action-arguments"] = {};
      }
      if (!has(automation, "trigger-arguments")) {
        automation["trigger-arguments"] = {};
      }
      return automation;
    },
    async edit() {
      if (this.editing && this.shareSelection) {
        // Resetting the data prevents data overlapping when editing automation
        // with similar arguments.
        this.CLEAR_CURRENT_AUTOMATION();
        await this.$nextTick();
      }
      this.shareSelection = true;
      const automation = this.getCurrentAutomationClone();
      this.SET_EDITING(true);
      this.SET_CURRENT_AUTOMATION(automation);
      $("#page").animate({
        scrollTop: 0
      }, "slow");
    },
    async toggleEnableAutomation() {
      this.SET_CHANGING_AUTOMATION_STATUS(true);
      const automation = this.getCurrentAutomationClone();
      this.TOGGLE_AUTOMATION_DATA_ENABLE_BY_ID(this.automation.id);
      try {
        await this.SAVE_AUTOMATION(_objectSpread(_objectSpread({}, automation), {}, {
          triggerArguments: automation["trigger-arguments"],
          actionArguments: automation["action-arguments"],
          enabled: this.automation.enabled
        }));
        await this.LOAD_PLAN_LIMIT(this.currentPagePlan);
      } catch (error) {
        this.TOGGLE_AUTOMATION_DATA_ENABLE_BY_ID(this.automation.id);
      } finally {
        this.$nextTick(() => {
          this.SET_CHANGING_AUTOMATION_STATUS(false);
        });
      }
    },
    remove() {
      this.deleting = true;
      this.automationToDelete = {
        trigger: this.TRIGGER_BY_KEY(this.automation.trigger),
        action: this.ACTION_BY_KEY(this.automation.action),
        triggerArguments: this.automation["trigger-arguments"],
        actionArguments: this.automation["action-arguments"],
        id: this.automation.id
      };
    },
    getMultiOptionText({
      name,
      value
    }) {
      if (!name) return `${value} days`;
      return name;
    },
    disabledSwitch() {
      return this.changingAutomationStatus || this.IS_USAGE_RESTRICTED(this.currentPagePlan) && !this.automation.enabled;
    }
  })
});